import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { HealthAndSafety } from '@mui/icons-material';

const InsuranceBroker: React.FC = () => {
  return (
      <Box sx={{ p: 3 }}>
        <Card elevation={2}>
          <CardContent sx={{ textAlign: 'center', py: 8 }}>
            <HealthAndSafety sx={{ fontSize: 80, color: 'primary.main', mb: 3 }} />
            <Typography variant="h4" gutterBottom>
              Insurance Broker
            </Typography>
            <Typography variant="h5" color="text.secondary" gutterBottom>
              Coming Soon
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
              This feature is currently under development and will be available soon.
            </Typography>
          </CardContent>
        </Card>
      </Box>
  );
};

export default InsuranceBroker;
